import { baseApi } from "api/BaseApi";

import {
  SubscribeAnnouncementsPayload,
  SubscribeAnnouncementsResponse,
} from "./subscribe.types";

const SUBSCRIBE_BASE_URL = "v2/mail";

export const subscribeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    subscribeAnnouncements: build.mutation<
      SubscribeAnnouncementsResponse,
      SubscribeAnnouncementsPayload
    >({
      query: (body) => ({
        url: `${SUBSCRIBE_BASE_URL}/announcements/subscribe`,
        method: "POST",
        body,
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useSubscribeAnnouncementsMutation } = subscribeApi;
